import { useEffect } from "react";
import { ISelectOptions } from "../../../types/inputs";
import { Button } from "../../Atoms/Button";
import { InputFile } from "../../Atoms/InputFile";
import { Input } from "../../Atoms/Inputs/Input";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { TextArea } from "../../Atoms/TextArea";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useRefundForm } from "./useRefundForm";
import { MessageErroForm } from "../../Atoms/MessageErroForm";

export const RefundFormTemplate = () => {
  const {
    fileTypes,
    bancoOptions,
    motivosOptions,
    control,
    handleSubmit,
    watch,
    register,
    Controller,
    submitForm,
    errors,
  } = useRefundForm();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Formulário de Reembolso</Title>

        <S.FormReembolso onSubmit={handleSubmit(submitForm)}>
          <div>
            <>
              <Controller
                control={control}
                name="data.uuidMotivo"
                render={({ field: { onChange, value } }) => (
                  <SimpleSelect
                    options={motivosOptions}
                    id="motivo"
                    label="Motivo"
                    required
                    onChange={(e: ISelectOptions) => onChange(e?.value)}
                    value={
                      motivosOptions.find((e) => e.value === value) || null
                    }
                  />
                )}
              />
              {errors?.data?.uuidMotivo && (
                <MessageErroForm>
                  {errors?.data?.uuidMotivo?.message}
                </MessageErroForm>
              )}
            </>

            {motivosOptions?.find((i) => i.value === watch("data.uuidMotivo"))
              ?.label === "Outro" && (
              <div>
                <TextArea
                  {...register("data.outroMotivo")}
                  id="textarea"
                  placeholder="Escreva o motivo do reembolso...."
                />

                {errors?.data?.outroMotivo && (
                  <MessageErroForm>
                    {errors?.data?.outroMotivo?.message}
                  </MessageErroForm>
                )}
              </div>
            )}
          </div>

          <div>
            <h2>Dados Bancários</h2>
          </div>

          <div>
            <Input {...register("data.nome")} required id="name" label="Nome" />
            {errors?.data?.nome && (
              <MessageErroForm>{errors?.data?.nome?.message}</MessageErroForm>
            )}
          </div>

          <div>
            <Input
              {...register("data.cpfCnpj")}
              required
              maxLength={18}
              id="cpf"
              label="CPF/CNPJ"
            />
            {errors?.data?.cpfCnpj && (
              <MessageErroForm>
                {errors?.data?.cpfCnpj?.message}
              </MessageErroForm>
            )}
          </div>

          <div>
            <Controller
              control={control}
              name="data.codigoDoBanco"
              render={({ field: { onChange, value } }) => (
                <SimpleSelect
                  required
                  label="Banco"
                  options={bancoOptions}
                  inputId="banco"
                  onChange={(e: ISelectOptions) => onChange(e?.value)}
                  value={bancoOptions.find((e) => e.value === value) || null}
                />
              )}
            />

            {errors?.data?.codigoDoBanco && (
              <MessageErroForm>
                {errors?.data?.codigoDoBanco?.message}
              </MessageErroForm>
            )}
          </div>

          <div>
            <Input
              {...register("data.agencia")}
              required
              type="number"
              label="Agência"
              id="agencia"
            />

            {errors?.data?.agencia && (
              <MessageErroForm>
                {errors?.data?.agencia?.message}
              </MessageErroForm>
            )}
          </div>

          <div>
            <Input
              {...register("data.conta")}
              type="number"
              required
              label="Conta"
              id="conta"
            />

            {errors?.data?.conta && (
              <MessageErroForm>{errors?.data?.conta?.message}</MessageErroForm>
            )}
          </div>

          <div>
            <Input
              {...register("data.operacao")}
              type="number"
              label="Operação"
              id="operacao"
            />

            {errors?.data?.operacao && (
              <MessageErroForm>
                {errors?.data?.operacao?.message}
              </MessageErroForm>
            )}
          </div>

          <div>
            <Controller
              control={control}
              name="file"
              render={({ field: { onChange } }) => (
                <InputFile
                  required
                  id="file"
                  onChange={(f) => {
                    onChange(f?.file);
                  }}
                  fileTypes={fileTypes}
                />
              )}
            />

            {errors?.file && (
              <MessageErroForm>{errors?.file?.message}</MessageErroForm>
            )}
          </div>

          <div>
            <Button>Avançar</Button>
          </div>
        </S.FormReembolso>
      </S.Wrapper>

      <S.Info>
        <span>*</span>Caso o comprovante de pagamento não apresente as
        informações do pagador, só será realizado o reembolso ao cliente do
        agendamento.
      </S.Info>
    </S.Container>
  );
};
